import {WarehouseServiceModel} from '../../models/megalog/WarehouseService';
import {Injectable} from '@angular/core';
import * as ROUTES from '../../utils/ROUTES';
import {BasicService} from '../../utils/basic.service';
import {DataService} from '../util/data.service';
import {HttpClient} from '@angular/common/http';


@Injectable({
  providedIn: 'root',
})
export class WarehouseServiceService extends BasicService<WarehouseServiceModel> {


  constructor(
    private dataService: DataService,
    private http: HttpClient
  ) {
    super(dataService, http, ROUTES.WAREHOUSE_SERVICE_ROUTE);
  }
}
